module.exports = __webpack_public_path__ + "static/media/51_A.4b4417a4.png";